var RULE = {
    getMessage: function () {
        return "";
    },
    validate: function (value) {
        return !value;
    },
};
export default RULE;
